import { useEffect } from "react";
import { axiosPrivate } from "../api/axios";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

const useAxiosPrivate = () => {
        
        const refresh= useRefreshToken();
        const{auth} = useAuth();

        useEffect(()=>{

                const requestIntercept = axiosPrivate.interceptors.request.use(
                        config => {
                                if (!config.headers['Authorization']){
                                        config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                                }
                                return config;

                        }, (error)=> Promise.reject(error)
                );

                const responseIntercept = axiosPrivate.interceptors.response.use(
                        response=> response,
                        async (error) =>{
                                const prevRequest = error?.config;
                                // Gestisci sia 401 (unauthorized) che 403 (forbidden)
                                if ((error?.response?.status === 401 || error?.response?.status === 403) && !prevRequest?.sent){
                                        prevRequest.sent = true;
                                        try {
                                                const newAccessToken = await refresh();
                                                prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                                                return axiosPrivate(prevRequest);
                                        } catch (refreshError) {
                                                // Se il refresh fallisce, reindirizza al login
                                                return Promise.reject(refreshError);
                                        }
                                }
                                return Promise.reject(error);
                        }
                )
                return ()=>{
                        axiosPrivate.interceptors.request.eject(requestIntercept);
                        axiosPrivate.interceptors.response.eject(responseIntercept);
                }

        },[auth,refresh])


        return axiosPrivate;
}
 
export default useAxiosPrivate;